module.exports = new __parcel__URL__("jpd-prioritization-roadmap.4b4874ca.svg").toString();